import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const businessAccountSettingReducer = createReducer(initialState) ({
    [type.BUSINESS_ACCOUNT_BONUS_LIST]: (state, action) => ({
        ...state,
        business_account_bonus_list: action.payload
    }),
    
    [type.UPDATE_BUSINESS_ACCOUNT_BONUS_STATUS]: (state, action) => ({
        ...state,
        update_business_account_bonus_status: action.payload
    }),
});

export default businessAccountSettingReducer;